import { render, staticRenderFns } from "./_NormalSearchNav522.vue?vue&type=template&id=6710370c&scoped=true"
import script from "./_NormalSearchNav522.vue?vue&type=script&lang=js"
export * from "./_NormalSearchNav522.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6710370c",
  null
  
)

export default component.exports